export default import.meta.ROLLUP_FILE_URL_JNmt8A6bkT7Hm2nCjpobPg